import axios from 'axios'
import type {CertificateIssuance} from './certificateTypes'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchCertificate(verificationCode: string): Promise<CertificateIssuance> {
  const {data} = await axios.get<CertificateIssuance>(
    `${API_URL}/learning-studio/certificates/verify/${encodeURIComponent(verificationCode)}`
  )
  return data
}

export function certificateFileUrl(path: string, download = false): string {
  return `${API_URL}${path}${download ? '?download=true' : ''}`
}
